import { gql } from '@apollo/client'

/** What was supplied to a generation, as stored: shared by every result that shows its basis. */
export const GENERATION_BASIS_VIEW_FIELDS = `
    recordId
    sources {
        source
        mode
        state
        reason
        as_of
        notApplied
    }
    items {
        key
        source
        kind
        text
        fields
        redacted
    }
    citedKeys
`

/** The sources, items and hash that the next generation of a purpose would use. */
export const GET_GENERATION_BASIS = gql`
    query GenerationBasis($campaignId: String!, $purpose: GenerationBasisPurpose!) {
        generationBasis(campaignId: $campaignId, purpose: $purpose) {
            purpose
            basisHash
            sources {
                source
                mode
                automatedAllowed
                state
                reason
                as_of
            }
            items {
                key
                source
                kind
                text
                fields
                state
                evidence
            }
        }
    }
`

/** Approves or excludes an item; a null decision removes the user's decision. */
export const SET_GENERATION_BASIS_DECISION = gql`
    mutation SetGenerationBasisDecision(
        $campaignId: String!
        $source: String!
        $itemKey: String!
        $decision: GenerationBasisDecisionValue
    ) {
        setGenerationBasisDecision(campaignId: $campaignId, source: $source, itemKey: $itemKey, decision: $decision) {
            source
            itemKey
            decision
        }
    }
`

/** Chooses manual or automated mode of a source for the licence. */
export const SET_GENERATION_BASIS_MODE = gql`
    mutation SetGenerationBasisMode($campaignId: String!, $source: String!, $mode: GenerationBasisMode!) {
        setGenerationBasisMode(campaignId: $campaignId, source: $source, mode: $mode) {
            source
            mode
        }
    }
`
